import type { BellItem, FollowTarget } from "@nexxt/app-kit";
import type { LinkOptions } from "@tanstack/react-router";

// The page of Atelier of an item of the bell (ADR-280): the emails of the external users link only to Atelier itself,
// so the page is said here, from what the item is about.

export function linkOf({ entityType, entityId }: Pick<BellItem, "entityType" | "entityId">): LinkOptions | null {
  if (entityId === null) return null;
  switch (entityType) {
    case "catalog.linesheet":
      return { to: "/linesheets/$linesheetId", params: { linesheetId: entityId } };
    case "catalog.attribute_task":
      return { to: "/attributes/$taskId", params: { taskId: entityId } };
    case "procurement.purchase_order":
      return { to: "/purchase-orders/$purchaseOrderId", params: { purchaseOrderId: entityId } };
    case "procurement.inbound":
      return { to: "/inbounds/$inboundKey", params: { inboundKey: entityId } };
    case "logistics.stock_movement":
      return { to: "/vendor-returns/$vendorReturnId", params: { vendorReturnId: entityId } };
    default:
      return null;
  }
}

/** The page of an object the user follows (ADR-281): the one its bell rows lead to. */
export const followedLink = ({ entityType, entityId }: FollowTarget): LinkOptions | null =>
  linkOf({ entityType, entityId });
